export default "<ion-app>\r\n  <app-sidenav main=\"main\"></app-sidenav>\r\n\r\n  <ion-router-outlet id=\"main\"></ion-router-outlet>\r\n</ion-app>\r\n";